<footer class="footer-area">
    <div class="divider"></div>
    <div class="container">
        <div class="copyright-area">
            <p>© 2026 Manda Ravalison. Built with Angular & Passion.</p>
        </div>
    </div>
</footer>

<div class="go-top" [class.active]="isShow" (click)="goToTop()">
    <i class="bx bx-chevron-up"></i>
</div>
